import React from 'react';
import CreateDeviceSection from './createDeviceSection';

export default function deviceSteps(setNewDevice, newDevice, onOsSelected) {
  const steps = [
    {
      title: 'Create Devices',
      label: 'Select the operating system for this device',
      body: (
        <CreateDeviceSection
          setNewDevice={setNewDevice}
          newDevice={newDevice}
          mode="os"
          onOsSelected={onOsSelected}
        />
      ),
      previousButtonLabel: 'Cancel'
    }
  ];

  if (newDevice?.os === 'windows') {
    steps.push({
      title: 'Download Windows App',
      label: 'Download the Windows application to install AdMobilize Vision',
      body: <CreateDeviceSection setNewDevice={setNewDevice} newDevice={newDevice} mode="windows" />,
      previousButtonLabel: 'Previous',
      nextButtonLabel: 'Close'
    });
  }

  if (newDevice?.os === 'linux') {
    steps.push({
      title: 'Create Linux Device',
      label: 'Devices will be available to assign later',
      body: <CreateDeviceSection setNewDevice={setNewDevice} newDevice={newDevice} mode="linux" />,
      previousButtonLabel: 'Previous',
      nextButtonLabel: 'Create',
      isNextDisabled: device => {
        return (
          !device ||
          device?.hasErrors?.['device-display-name'] ||
          !device?.site?.value ||
          device?.os !== 'linux'
        );
      }
    });
  }

  return steps;
}
